<template>
  <div style="min-height: 65vh">
    <div class="py-12">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
};
</script>

<style lang="scss" scoped></style>
